import React from "react";
import { observer } from "mobx-react";
import { RoleViewStore } from "../../store";
import { RoleViewForm } from "./RoleViewForm";
import { ErrorDialog } from "../../../../common/controls";

export type RoleViewProps = {
  roleViewStore: RoleViewStore;
};

export const RoleView: React.FC<RoleViewProps> = observer(
  ({ roleViewStore }) => {
    return (
      <div>
        <RoleViewForm
          name_es={roleViewStore.name_esValue}
          name_en={roleViewStore.name_enValue}
          name_pt={roleViewStore.name_ptValue}
          permissionsValues={roleViewStore.permissionsValues}
          audience={roleViewStore.audienceValue}
          isForAllTenants={roleViewStore.isForAllTenantsValue}
          onPrint={(handlePrint: () => void) =>
            roleViewStore.printRole(handlePrint)
          }
          onCancel={() => roleViewStore.cancelRole()}
          onEdit={
            roleViewStore.isEditEnabled
              ? () => roleViewStore.editRole()
              : undefined
          }
        />
        <ErrorDialog
          open={roleViewStore.errorDialogOpened}
          title={roleViewStore.errorTitle}
          description={roleViewStore.errorDescription}
          onClose={() => roleViewStore.closeErrorDialog()}
        />
      </div>
    );
  }
);
